/** @format */

import ViewBox from 'frontier/components/die_template/view_box';
import {
    bleedlineStyle,
    dielineStyle,
    safeZoneStyle
} from 'frontier/components/die_template/line_styles';
import React from 'react';

export default function RectSvg({
    isSquareCorners,
    isShowingBleedlines = true,
    isShowingSafeZone = true,
    ...props
}) {
    let roundedRadius = 0.028;
    const bleed = 0.125;
    if (!isSquareCorners) {
        roundedRadius = props.width > '0.75' && props.length > '0.75' ? bleed : bleed / 2;
    }

    return (
        <ViewBox width={props.width + bleed} length={props.length + bleed}>
            {isShowingBleedlines && (
                <rect
                    id="Bleedline"
                    width={props.width + bleed}
                    height={props.length + bleed}
                    rx={roundedRadius}
                    ry={roundedRadius}
                    style={bleedlineStyle}
                />
            )}
            <rect
                id="Dieline"
                width={props.width}
                height={props.length}
                x={bleed / 2}
                y={bleed / 2}
                rx={roundedRadius}
                ry={roundedRadius}
                style={dielineStyle}
            />
            {isShowingSafeZone && (
                <rect
                    id="Safezone"
                    width={props.width - bleed}
                    height={props.length - bleed}
                    x={bleed}
                    y={bleed}
                    rx={roundedRadius}
                    ry={roundedRadius}
                    style={safeZoneStyle}
                />
            )}
        </ViewBox>
    );
}
